import { createRouter, createWebHistory } from 'vue-router';
import { useDelivererAuthStore } from '../stores/auth';

function getBase(): string {
    if (window.location.pathname.startsWith('/pwa/deliverer')) return '/pwa/deliverer/';
    return '/';
}

const PUBLIC_PATHS = ['/login', '/activate', '/forgot-password', '/reset-password'];

const router = createRouter({
    history: createWebHistory(getBase()),
    routes: [
        { path: '/', redirect: '/pedidos' },
        { path: '/pedidos',                              name: 'pedidos',          component: () => import('../pages/Pedidos.vue') },
        { path: '/pedidos/:id/confirmar-entrega',        name: 'confirmar-entrega', component: () => import('../pages/ConfirmarEntrega.vue') },
        { path: '/pedidos/:id/reportar-problema',        name: 'reportar-problema', component: () => import('../pages/ReportarProblema.vue') },
        { path: '/hoje',                                 name: 'hoje',             component: () => import('../pages/Hoje.vue') },
        { path: '/conta',                  name: 'conta',         component: () => import('../pages/Conta.vue') },
        { path: '/conta/dados-pessoais',   name: 'dados-pessoais', component: () => import('../pages/DadosPessoais.vue') },
        { path: '/conta/veiculo',          name: 'veiculo',        component: () => import('../pages/Veiculo.vue') },
        { path: '/conta/repasses',         name: 'repasses',       component: () => import('../pages/Repasses.vue') },
        { path: '/login',            name: 'login',          component: () => import('../pages/Login.vue') },
        { path: '/activate/:token',  name: 'activate',       component: () => import('../pages/ActivateAccount.vue') },
        { path: '/forgot-password',  name: 'forgot',         component: () => import('../pages/ForgotPassword.vue') },
        { path: '/reset-password',   name: 'reset-password', component: () => import('../pages/ResetPassword.vue') },
    ],
});

router.beforeEach((to, _from, next) => {
    const auth = useDelivererAuthStore();
    const isPublic = PUBLIC_PATHS.some(p => to.path.startsWith(p));
    if (!isPublic && !auth.isAuthenticated) {
        next('/login');
    } else {
        next();
    }
});

// Recarrega a página quando o hash do bundle muda (deploy novo durante a sessão).
router.onError((error) => {
    const msg = error.message ?? '';
    if (
        msg.includes('Failed to fetch dynamically imported module') ||
        msg.includes('Importing a module script failed') ||
        msg.includes('error loading dynamically imported module')
    ) {
        window.location.reload();
    }
});

export default router;
